module.exports = __webpack_public_path__ + "img/ORandD_Logo_white.24966038.png";